export enum httpStatusCodes {
  unauthorized = 401,
  forbidden = 403,
}
